import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authToken, setAuthToken] = useState(
    () => localStorage.getItem("accessToken") || null
  );

  const [refreshToken, setRefreshToken] = useState(
    () => localStorage.getItem("refreshToken") || null
  );

  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    if (authToken) {
      localStorage.setItem("accessToken", authToken);
    } else {
      localStorage.removeItem("accessToken");
    }
  }, [authToken]);

  useEffect(() => {
    if (refreshToken) {
      localStorage.setItem("refreshToken", refreshToken);
    } else {
      localStorage.removeItem("refreshToken");
    }
  }, [refreshToken]);

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  const login = (data) => {
    const access = data.tokens.access.token;
    const refresh = data.tokens.refresh.token;

    setAuthToken(access);
    setRefreshToken(refresh);
    setUser(data.user);
  };

  const logout = () => {
    setAuthToken(null);
    setRefreshToken(null);
    setUser(null);

    localStorage.clear();
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        refreshToken,
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);